<div class="row">
  <h3 class="col">Distribuição de limites - Configurações </h3>
</div>

<div class="container">
  <bn-paginacao [total]="atributosPaginacao().count"
        [tamanhoPagina]="atributosPaginacao().pageSize" [numPagina]="atributosPaginacao().page"
        [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">
    <div class="table-responsive">
      <table class="table table-hover fonte">
        <thead>
          <tr >
            <th id="col-numero" scope="col">
              <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'numero'" [nomeAtributoExibicao]="'Número do Ciclo'"
                (aoClickar)="mudancaOrdenacao($event)">
              </bn-ordenacao>
            </th>
            <th id="col-numeroTranche" scope="col">
              <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'numeroTranche'" [nomeAtributoExibicao]="'Tranche'"
                (aoClickar)="mudancaOrdenacao($event)">
              </bn-ordenacao>
            </th>
            <th id="col-dataInicio" scope="col">
              <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataInicio'" [nomeAtributoExibicao]="'Data de Início'"
                (aoClickar)="mudancaOrdenacao($event)">
              </bn-ordenacao>
            </th>
            <th id="col-dataFim" scope="col">
              <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataFim'" [nomeAtributoExibicao]="'Data de Fim'"
                (aoClickar)="mudancaOrdenacao($event)">
              </bn-ordenacao>
            </th>
            <th id="col-valorAporte" scope="col">
              <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'valorAporte'" [nomeAtributoExibicao]="'Valor'"
                (aoClickar)="mudancaOrdenacao($event)">
              </bn-ordenacao>
            </th>
            <th id="col-ignoraMetas" scope="col">
              <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'ignoraMetas'" [nomeAtributoExibicao]="'Ignora Metas'"
                (aoClickar)="mudancaOrdenacao($event)">
              </bn-ordenacao>
            </th>
            <th scope="col" class="text-start">
              Acões
            </th>
          </tr>
        </thead>
        <tbody>
          @for (tuplaCiclo of ciclosPaginados; track tuplaCiclo.objeto.id) {
            <tr id="corpo-lista" class="fonte">
              <td><span>{{ tuplaCiclo.objeto.numero }}</span></td>
              <td><span>{{ tuplaCiclo.objeto.numeroTranche }}</span></td>
              <td><span>{{ tuplaCiclo.objeto.dataInicio | date: 'dd/MM/yy'}}</span></td>
              <td><span>{{ tuplaCiclo.objeto.dataFim | date: 'dd/MM/yy'}}</span></td>
              <td><span>{{ tuplaCiclo.objeto.valorAporte | bnMask: 'MOEDA'}}</span></td>
              <td>
                <div>
                  @if (tuplaCiclo.permiteEdicao) {
                    <input type="checkbox" (click)="$event.stopPropagation()" [(ngModel)]='tuplaCiclo.objeto.ignoraMetas' 
                  (ngModelChange)="pedirConfirmacao(tuplaCiclo)" class="form-check checkbox-gigante">
                  } @else {
                    <span>{{ tuplaCiclo.objeto.ignoraMetas ? 'Sim' : 'Não' }}</span>
                  }
                </div>
              </td>
              <td class="text-start" id=col-acoes>
                @if (!ambientePrd()) {
                  <a href="javascript:void(0)" class="ms-2" (click)="reverter($event, tuplaCiclo)"
                     ngbTooltip="Reverter Ciclo de Distribuição"><i class="fa fa-arrow-rotate-left"></i></a>
                }
                <a href="javascript:void(0)" class="ms-2" (click)="permitirEdicao($event, tuplaCiclo)"
                   [ngbTooltip]="podeEditar(tuplaCiclo) ? 'Editar Ciclo de Distribuição' : 'Não é possível editar um Ciclo fechado'" 
                   [ngClass]="!podeEditar(tuplaCiclo) ? 'text-secondary text-opacity-50' : ''" ><i class="fa fa-pencil-square-o"></i></a>
                <a [routerLink]="['/distribuicao-limites-detalhes', tuplaCiclo.objeto.id]"
                   [state]="{
                      ciclo: tuplaCiclo.objeto,
                      page: atributosPaginacao().page,
                      pageSize: atributosPaginacao().pageSize,
                      atributoOrdenacao: atributosOrdenacao.atributo,
                      sentidoOrdenacao: atributosOrdenacao.sentido
                   }"
                   class="ms-2"
                   (click)="$event.stopPropagation()"
                   ngbTooltip="Visualizar Detalhes do Ciclo de Distribuição">
                  <i class="fa fa-search" aria-hidden="true"></i>
                </a>
                
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </bn-paginacao>
</div>